import { FC, PropsWithChildren, useState } from 'react';
import { Omit } from 'lodash';

import classNames from 'classnames';
import { useIonModal } from '@ionic/react';
import { useTheme } from 'styled-components';

import { Typography } from '../Typography/Typography';
import { Icon } from '../Icon';

import { ICON_NAME_MAPPING } from './Hint.const';
import { HintModal, HintModalProps } from './HintModal/HintModal';

import styles from './Hint.module.scss';

export type HintProps = PropsWithChildren<
  Omit<HintModalProps, 'dissmiss'> & { className?: string }
>;

export const Hint: FC<HintProps> = ({
  children,
  className,
  variant = 'info',
  ...props
}) => {
  const { isDesktop } = useTheme();

  const [modalProps, setModalProps] = useState<HintModalProps>();

  const [show, dissmiss] = useIonModal(HintModal, modalProps);

  const content = (() => {
    if (typeof children === 'string') {
      return <Typography variant="p2">{children}</Typography>;
    }
    return children;
  })();

  const handleOnClick = () => {
    setModalProps({ variant, dissmiss, ...props });
    show({
      handle: false,
      initialBreakpoint: 1,
      backdropDismiss: false,
      cssClass: classNames(styles.modal, {
        [styles.desktop]: isDesktop,
      }),
      breakpoints: !isDesktop ? [0, 1] : undefined,
    });
  };

  return (
    <div
      className={classNames(styles.root, styles[variant], className)}
      onClick={handleOnClick}
    >
      <Icon name={ICON_NAME_MAPPING[variant]} />
      <div>{content}</div>
    </div>
  );
};
